export const TRANSFER_STATUS = {
  DRAFT: 0,
  REQUESTED: 1,
  SENT: 2,
  COMPLIANT: 3,
  NON_COMPLIANT: 4,
  INVOICED: 5,
};

export const TRANSFER_STATUS_LABELS = {
  [TRANSFER_STATUS.DRAFT]: 'STOCKS.TRANSFERS.STATUS_DRAFT',
  [TRANSFER_STATUS.REQUESTED]: 'STOCKS.TRANSFERS.STATUS_REQUESTED',
  [TRANSFER_STATUS.SENT]: 'STOCKS.TRANSFERS.STATUS_SENT',
  [TRANSFER_STATUS.NON_COMPLIANT]: 'STOCKS.TRANSFERS.STATUS_NON_COMPLIANT',
  [TRANSFER_STATUS.COMPLIANT]: 'STOCKS.TRANSFERS.STATUS_COMPLIANT',
  [TRANSFER_STATUS.INVOICED]: 'STOCKS.TRANSFERS.STATUS_INVOICED',
};

export const transferStatusLegend = {
  [TRANSFER_STATUS.DRAFT]: {
    name: 'STOCKS.TRANSFERS.STATUS_DRAFT',
    color: 'grey',
  },
  [TRANSFER_STATUS.REQUESTED]: {
    name: 'STOCKS.TRANSFERS.STATUS_REQUESTED',
    color: 'black',
  },
  [TRANSFER_STATUS.SENT]: {
    name: 'STOCKS.TRANSFERS.STATUS_SENT',
    color: 'black',
  },
  [TRANSFER_STATUS.NON_COMPLIANT]: {
    name: 'STOCKS.TRANSFERS.STATUS_NON_COMPLIANT',
    color: 'red',
  },
  [TRANSFER_STATUS.COMPLIANT]: {
    name: 'STOCKS.TRANSFERS.STATUS_COMPLIANT',
    color: 'green',
  },
  [TRANSFER_STATUS.INVOICED]: {
    name: 'STOCKS.TRANSFERS.STATUS_INVOICED',
    color: 'green',
  },
};

export const transferStatusColorCodes = [
  {
    id: String(TRANSFER_STATUS.DRAFT),
    name: 'STOCKS.TRANSFERS.STATUS_DRAFT',
    color: 'grey-2',
    inpulseColor: 'grey',
  },
  {
    id: String(TRANSFER_STATUS.REQUESTED),
    name: 'STOCKS.TRANSFERS.STATUS_REQUESTED',
    color: 'black',
    inpulseColor: 'black',
  },
  {
    id: String(TRANSFER_STATUS.SENT),
    name: 'STOCKS.TRANSFERS.STATUS_SENT',
    color: 'black',
    inpulseColor: 'black',
  },
  {
    id: String(TRANSFER_STATUS.NON_COMPLIANT),
    name: 'STOCKS.TRANSFERS.STATUS_NON_COMPLIANT',
    color: 'red',
    inpulseColor: 'red',
  },
  {
    id: String(TRANSFER_STATUS.COMPLIANT),
    name: 'STOCKS.TRANSFERS.STATUS_COMPLIANT',
    color: 'green',
    inpulseColor: 'green',
  },
  {
    id: String(TRANSFER_STATUS.INVOICED),
    name: 'STOCKS.TRANSFERS.STATUS_INVOICED',
    color: 'green',
    inpulseColor: 'green',
  },
];

export const TRANSFER_DETAILS_VIEW = {
  DRAFT: 'DRAFT',
  DELIVERY: 'DELIVERY',
  RECEPTION: 'RECEPTION',
  SENDER_DISABLED: 'SENDER_DISABLED',
  DISABLED: 'DISABLED',
};
